import { graphql } from "relay-runtime"

export const chApproveAndGenerateCarePlanDocumentMutation = graphql`
  mutation chApproveAndGenerateCarePlanDocumentMutation(
    $input: Ch_approveAndGenerateCarePlanDocumentInput!
    $connections: [ID!]!
  ) {
    approveAndGenerateCarePlanDocument: ch_approveAndGenerateCarePlanDocument(input: $input) {
      carePlanSummary @prependNode(connections: $connections, edgeTypeName: "Ch_carePlanSummaryEdge") {
        id
        treatmentPlan {
          title
          followUpTreatment
          recommendedTreatment
          from
          to
        }
        fileId
        progressNoteId
        signedBy
        signedAt
        updatedAt
        createdAt
        updatedBy
        createdBy
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
